import React from 'react';
import MenuItemAnchor, {MenuItemAnchorProps} from './MenuItemAnchor';
import startsWith from 'lodash/startsWith';
import gettext from '../../utils/django/gettext';

const sharedProps = {
    href: '/hike/',
    children: gettext('Hikes'),
};

function Toolbar({style, ...props}: React.HTMLProps<HTMLAnchorElement>) {
    const isActive = startsWith(window.location.pathname, '/hike/');

    return <a {...props} {...sharedProps} style={{
        ...style,
        borderBottomWidth: isActive ? 3 : 0,
        marginTop: isActive ? 3 : 0,
    }} />;
}

function HamburgerMenu(props: MenuItemAnchorProps) {
    return <MenuItemAnchor {...props} {...sharedProps} />;
}

export default {Toolbar, HamburgerMenu};
